import React, {useEffect, useState, useSyncExternalStore} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import { Alert } from 'react-bootstrap';

function GrillaEmpresa (props){
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [rutempresa, setRutEmpresa] = useState()
    const [nombreempresa, setNombreEmpresa] = useState('')
    const [direccionempresa, setDireccionEmpresa] = useState('')
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')

    let statuscall = '' 
    
    const dataList = datos.map((item, i) => 
    <div key={i} className='boLineGrilla'>
         <div className='boLineIndexGrilla'>{i + 1}</div>
         <div className='boLinePrincipalContentGrilla'>{item.rut}</div>
         <div className='boLinePrincipalContentGrilla'>{item.nombre}</div>
         <div className='boLinePrincipalContentGrilla'>{item.direccion}</div>
         <div className='boLinePrincipalContentGrilla'><button onClick={() => clickEmpresa(item)}>Modificar</button></div>
    </div>);

    const handleClassWaitProcess = async (e) =>{
        setClassWaitProcess('waitProcessV')
    }

    const handleDireccion = async (e) =>{
        setDireccionEmpresa(e.target.value)
    }    

    const handleNombre = async (e) =>{
        setNombreEmpresa(e.target.value)
    }

    const putEmpresa = async () =>{
        setClassWaitProcess('waitProcessV')
        if(nombreempresa != '')
        {
            if(direccionempresa != '')
            {
                let urlput = process.env.REACT_APP_URLPUTEMPRESA+rutempresa.toString()+'/update'
                let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
                const data = {   
                    nombre: nombreempresa,
                    direccion: direccionempresa,
                };
        
                const casinoPut = await Axios.put(urlput, data,{
                    timeout: process.env.REACT_APP_TIMEOUT,
                    headers: {
                        'Access-Control-Allow-Origin' : '*',
                        'Access-Control-Allow-Methods': 'GET, POST, PUT',
                        'Access-Control-Allow-Headers': 'Content-Type'
                }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                
                if(statuscall.status == 200)
                {   
                    setClassWaitProcess('waitProcess')
                    handleGrillaEmpresa()
                    setTituloAlert('Modidifacion de empresas')
                    setTextoAlert('Empresa actualizada')
                    setClaseAlert('success alertFlotante opacity-100')
                    setAlert(true)
                    setTimeout(() => {
                        setAlert(false)
                    }, 3000)

                    setTimeout(() =>{
                        handleClose()
                    }, 3500)
                }
                else
                {
                    if(statuscall.status == 0)
                    {
                        setClassWaitProcess('waitProcess')
                        setTituloAlert('Modidifacion de empresas')
                        setTextoAlert('Servidor no responde. Intentelo mas tarde')
                        setClaseAlert('danger alertFlotante opacity-100')
                        setAlert(true)
                        setTimeout(() => {
                            setAlert(false)
                        }, 4000)
                    }
                }
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert('Modificacion de empresas')
                setTextoAlert('Debe ingresar una dirección')
                setClaseAlert('warning alertFlotante opacity-100')
                setAlert(true)
                setTimeout(() => {
                    setAlert(false)
                }, 4000)                
            }
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert('Modidifacion de empresas')
            setTextoAlert('Debe ingresar una nombre')
            setClaseAlert('warning alertFlotante opacity-100')
            setAlert(true)
            setTimeout(() => {
                setAlert(false)
            }, 4000)
        }
    }

    const handleGrillaEmpresa = async () =>{
        Axios.get(process.env.REACT_APP_URLGETENTERPRISES,{
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }            
        }).then((response) => {
            setDatos(response.data.enterprises)
            setDatosBackup(response.data.enterprises)    
        }).catch(error =>{
            return error
        })
    }

    useEffect(() => {
        Axios.get(process.env.REACT_APP_URLGETENTERPRISES,{
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }            
        }).then((response) => {
            setDatos(response.data.enterprises)
            setDatosBackup(response.data.enterprises)    
        }).catch(error =>{
            return error
        })
    },[])

    const clickEmpresa= (item) =>{
        setRutEmpresa(item.rut)
        setNombreEmpresa(item.nombre)
        setDireccionEmpresa(item.direccion)
        handleShow()
    }

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        console.log("Busqueda: " + e.target.value)
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataNombre = item.nombre.toUpperCase()
                const campo = itemDataNombre
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
        console.log(newData)
        console.log(datos)
    }

    return(
    <div className='boSeccionGrilla'>
        <div className='boSeccionGrillaTitle'>
            Lista Empresas
        </div>
        <div className='boSeccionGrillaSearch'>
            <input type='search' onChange={handleChangeList} placeholder='Buscar'></input>
        </div>

        <div className='boGrilla'>
            <div className='boLineGrillaTitulo'>
                <div className='boLineIndexGrilla'>T</div>
                <div className='boLinePrincipalContentGrilla'>Rut</div>
                <div className='boLinePrincipalContentGrilla'>Nombre</div>
                <div className='boLinePrincipalContentGrilla'>Direccion</div>
                <div className='boLinePrincipalContentGrilla'>Controles</div>
            </div>
            {dataList}
        </div>

        <div className='row'>

        <div className='col col-lg-12'>
            
            <Modal show={show} onHide={handleClose} size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title>Crear Empresa</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className={classWaitProcess}>
                        <div className='loaderS divAbsolute'>
                        </div>
                    </div>

                    <div className='row divAbsolute'>
                        <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col col-lg-6'>
                            Rut empresa                                                                    
                        </div>
                        <div className='col col-lg-6'>
                            <input type='text' disabled='true' value={rutempresa}></input>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col col-lg-6'>
                            Nombre empresa     
                        </div>
                        <div className='col col-lg-6'>
                            <input type='text' onChange={handleNombre} value={nombreempresa}></input>
                        
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col col-lg-6'>
                            Direccion empresa                                                                    
                        </div>
                        <div className='col col-lg-6'>
                            <input type='text' onChange={handleDireccion} value={direccionempresa}></input>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleClose}>
                        Cerrar
                    </button>
                    <button onClick={putEmpresa}>
                        Modificar
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
        </div>                                                                                                                                                                                           
    </div>    
    )
}
export default GrillaEmpresa